export default "__VITE_ASSET__DpK3Gn96__"